export const getFileNameExtension = (fileName: string | null) => {
  if (fileName) {
    const splitted = fileName.split('.');
    return splitted[splitted.length - 1];
  }
  return undefined;
};
